import { merge } from 'lodash';
import VueI18n from 'vue-i18n';

import { fetchLocale } from './fetch-locale';
import { I18N_FALLBACK_CONF } from '@skinsoft/config'

declare const config
const FALLBACK_LOCALE = config.fallback_locale

let instance = null as any;

export function createInstance(messages, locale = FALLBACK_LOCALE, dateTimeFormats) {
    return new VueI18n({
        dateTimeFormats,
        fallbackLocale: I18N_FALLBACK_CONF,
        silentFallbackWarn: true,
        locale,
        messages,
    });
}

export async function i18n(messages, dateTimeFormats): Promise<VueI18n> {
    if (instance) {
        return instance;
    }

    const locale = localStorage.getItem('preferredLocale') || navigator.language.split('-')[0] || FALLBACK_LOCALE;
    let remoteMessages = {};

    try {
        remoteMessages = await fetchLocale(locale)
    } catch (error) {
        // tslint:disable-next-line:no-console
        console.error("An error happened while fetching translations")
        console.error(error);
    }

    instance = createInstance(merge(remoteMessages, messages), locale, dateTimeFormats);

    return instance;
}
